import { useEffect } from 'react'
import gql from 'graphql-tag'
import { useGqlModalActivityFilterQuery } from 'generated/graphql'
import useJobCategoryStore from '@app.feature/jobCategory/store/store.jobCategory'
import { ActivityTypeID } from 'constants/enums'
import { TActivityFilterStoreFilterBy } from '../store/slice/baseSlice'
import useActivityFilterStore from '../store/storeActivityFilter'

type TUseModalActivityFilterOption = {
  activityTypeId: ActivityTypeID
  open?: boolean
  defaultFilterBy?: TActivityFilterStoreFilterBy
}

gql`
  query gqlModalActivityFilter($input: ActivityFilterListInput!) {
    activityFilterList(input: $input) {
      ...BaseSlice_activityFilterListItem
    }
  }
`

export const useModalActivityFilterEffect = (
  options: TUseModalActivityFilterOption,
) => {
  const { activityTypeId, open, defaultFilterBy } = options

  const { data } = useGqlModalActivityFilterQuery({
    variables: {
      input: {
        activityTypeID: activityTypeId,
      },
    },
  })

  const getChainingLabelById = useJobCategoryStore(
    (state) => state.getChainingLabelById,
  )
  const getInternTypeLabelById = useJobCategoryStore(
    (state) => state.getInternTypeLabelById,
  )

  const setActivityType = useActivityFilterStore(
    (state) => state.setActivityType,
  )
  const initFilterBy = useActivityFilterStore((state) => state.initFilterBy)

  useEffect(() => {
    const filteredData = data?.activityFilterList?.map((list) => ({
      ...list,
      // data result organizationTypes name is deprecated.
      // to use orgTypeIds
      name: list.name === 'organizationTypes' ? 'orgTypeIDs' : list.name,
    }))

    if (open && filteredData) {
      setActivityType(activityTypeId)
      initFilterBy({
        filterBy: defaultFilterBy || {},
        filterData: filteredData,
        especiallyLabelMaps: [
          {
            key: 'categoryIDs',
            getLabelFunction: getChainingLabelById,
          },
          {
            key: 'internTypeIds',
            getLabelFunction: getInternTypeLabelById,
          },
        ],
      })
    }
  }, [activityTypeId, open, defaultFilterBy, data])
}
